<template>
  <div class="mt-5 md:mt-8">
    <div class="container no-print">
      <CommonSectionLabel
        class="no-print order-1 lg:order-none"
        title="Birthdays"
        add-header-tag
      />
      <LayoutColumns>
        <template #left>
          <AdsConceptAd class="lg:hidden order-last" id="altinget-mob2" />
          <ListNames
            class="order-last lg:order-none"
            :count="3"
            placement="side"
          />
          <AdsConceptAd
            v-if="isSite('altinget_dk')"
            :id="`${config.public.site.ads?.placementPrefix}-mkt-promo1`"
            class="order-last lg:order-none"
          />
          <ListArticles
            class="order-last lg:order-none"
            :count="5"
            :offset="0"
            :paper="1"
            label="FrontpageNow"
            type="instream"
            placement="side"
          />
        </template>
        <template #main>
          <ListBirthdays
            class="order-2 lg:order-none"
            :count="100"
            placement="main"
          />
        </template>
        <template #right>
          <AdsConceptAd
            v-if="isSite('altinget_no')"
            class="no-print lg:hidden"
            id="altinget-mob3"
          />
          <ListJobs class="order-4 lg:order-none" :count="5" :random="true" />
          <AdsConceptAd class="hidden lg:block" id="altinget-rec1" />
          <ListMostRead class="order-last lg:order-none" />
        </template>
      </LayoutColumns>
    </div>
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()

const indexStore = useIndexStore()

if (!indexStore.currentPaper) {
  throw createError({ statusCode: 404 })
}

useSeoMeta({
  title: indexStore.currentPaperSlug
    ? config.public.site.meta.title.postfix.short +
      indexStore.currentPaper?.Name
    : config.public.site.meta.title.postfix.long,
})
</script>
